import React, { useEffect } from "react";
import "../scss/kakao.scss";
const { kakao } = window;


function KakaoMap(x, y, mapId) {
  useEffect(() => {
    var mapContainer = document.getElementById(mapId), // 지도를 표시할 div 
      mapOption = {
        center: new kakao.maps.LatLng(x, y), // 지도의 중심좌표
        level: 3 // 지도의 확대 레벨
      };

    var map = new kakao.maps.Map(mapContainer, mapOption); // 지도를 생성합니다

    // 마커가 표시될 위치입니다 
    var markerPosition = new kakao.maps.LatLng(x, y);

    // 마커를 생성합니다
    var marker = new kakao.maps.Marker({
      position: markerPosition
    });

    // 마커가 지도 위에 표시되도록 설정합니다
    marker.setMap(map);
  }, [])
  return (
    <>
      <div id={mapId}></div>

      <div className="address">
        <div className="wrap2">
          <ol>
            <li>
              <h2>Address</h2>
              <div></div>
              <p>대구 수성구 동대구로 6길 66 1층</p>
            </li>
            <li>
              <h2>E-mail</h2>
              <div></div>
              <p>cs@coren.co.kr</p>
            </li>
            <li>
              <h2>Tel</h2>
              <div></div>
              <p>070-4210-8988</p>
            </li>
          </ol>
        </div>
      </div>
    </>
  )
}

export default KakaoMap;